<div *ngIf="task" class="layout-row layout-align-start-center font-weight-400">
  <span *ngIf="!task.taskSpec.externalEta && !task.taskSpec.externalPlannedEta"
        [ngClass]="{'eta-late font-weight-600': task.analysis?.late > 0}">
      {{task.analysis | bringozTime: 'eta'}}
  </span>

  <span *ngIf="task.taskSpec.externalEta || task.taskSpec.externalPlannedEta"
        [ngClass]="{'eta-late font-weight-600': (task.taskSpec.externalEta - task.taskSpec.externalPlannedEta > 0) || (currentTime > task.taskSpec.externalPlannedEta)}">
      {{task.taskSpec | bringozTime: 'externalEta'}}
  </span>


  <bringoz-icon *ngIf="(task.routeAnalysis?.eta ||
                  (task.analysis?.late > 0 && task.analysis?.eta) ||
                  (task.analysis?.eta && checkTimeZoneOffsetDiff()))
                  && (!task.taskSpec.externalEta && !task.taskSpec.externalPlannedEta)"
                class="margin-left-5"
                iconName="info-outline"
                fill="#0000008a"
                [ngbTooltip]="etaTooltip" openDelay="300" triggers="hover">

  </bringoz-icon>

  <bringoz-icon *ngIf="(task.taskSpec.externalPlannedEta ||
                  (task.taskSpec.externalEta && ((task.taskSpec.externalEta - task.taskSpec.externalPlannedEta) > 0 )) ||
                  (task.taskSpec.externalEta && checkTimeZoneOffsetDiff()))"
                class="margin-left-5"
                iconName="info-outline"
                fill="#0000008a"
                [ngbTooltip]="externalEtaTooltip" openDelay="300" triggers="hover">

  </bringoz-icon>

  <ng-template #etaTooltip>
    <div class="layout-column">

      <!--Time zone-->
      <div *ngIf="task.analysis?.eta && checkTimeZoneOffsetDiff()"
           class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-600">{{ 'Time Zone' | translate}}</span>
        <span class="br-body-2 margin-left-5 margin-right-5">{{task.analysis | bringozDate: 'eta': true:timeZoneId}}
          |</span>
        <span>{{timeZoneId}} ({{timeZoneOffsetDiff}}{{ 'hrs' | translate}})</span>
      </div>

      <!--Late-->
      <div *ngIf="task.analysis?.late > 0 && task.analysis?.eta" class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-600">{{ 'Late' | translate}}</span>
        <span class="br-body-2 margin-left-5">{{task.analysis?.eta | bringozTimeAgo}}</span>
      </div>

      <!--Planed ETA-->
      <div class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-600">{{ 'Planned ETA' | translate}}</span>
        <span class="br-body-2 margin-left-5">{{task.routeAnalysis | bringozTime: 'eta'}}</span>
      </div>

    </div>
  </ng-template>

  <ng-template #externalEtaTooltip>
    <div class="layout-column">

      <span class="br-body-2 font-weight-400" translate>External ETA</span>


      <!--Time zone-->
      <div *ngIf="task.taskSpec.externalEta && checkTimeZoneOffsetDiff()"
           class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-600">{{ 'Time Zone' | translate}}</span>
        <span
          class="br-body-2 margin-left-5 margin-right-5">{{task.taskSpec | bringozDate: 'externalEta': true:timeZoneId}}
          |</span>
        <span>{{timeZoneId}} ({{timeZoneOffsetDiff}}{{ 'hrs' | translate}})</span>
      </div>

      <!--Late-->
      <div *ngIf="((task.taskSpec.externalEta - task.taskSpec.externalPlannedEta) > 0 || (currentTime > task.taskSpec.externalPlannedEta)) && task.taskSpec.externalEta"
           class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-600">{{ 'Late' | translate}}</span>
        <span class="br-body-2 margin-left-5">{{task.taskSpec.externalEta | bringozTimeAgo}}</span>
      </div>

      <!--Planed ETA-->
      <div class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-600">{{ 'Planned ETA' | translate}}</span>
        <span class="br-body-2 margin-left-5">{{task.taskSpec | bringozTime: 'externalPlannedEta'}}</span>
      </div>

    </div>
  </ng-template>
</div>
